import { Component, Output, Input , EventEmitter, Injectable} from '@angular/core';

@Injectable({ providedIn: 'root' })
@Component({
    selector: 'upsell-product-box',
    templateUrl: 'upsell-product-box.html',
    styleUrls: ['upsell-product-box.scss'],
    standalone: false
})
export class UpsellProductBoxComponent {
  @Input() productBoxTitle: string = '';
  @Input() productBoxSubtitle: string = '';
  @Input() image: string = 'assets/img/No-Image-Available.jpg';
  @Input() imageAlt: string = '';
  @Input() regularPrice: number = 0;
  @Input() instantSavings: number = 0;
  @Input() yourPrice: number = 0;
  @Input() currency: string = 'USD';  // TOUC-14710

  @Input() buttonYesText: string = `Yes I want this special added to my order`;
  @Input() buttonNoText: string = `No thanks, I understand that I won't see this offer again`;
  @Input() productBoxCTA: boolean = false;

  @Input() regularText: string = 'Regular Price';
  @Input() instantSavingsText: string = 'Instant Savings';
  @Input() yourPriceText: string = 'Your Price';

  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  nextPage(buttonValue: boolean) {
    this.eventEmitter.emit(buttonValue);
  }

}
